module.exports = __webpack_public_path__ + "img/01-core-image-illustration-1-8-1.bb68fa2.png";